<script setup>
import {mapErrors} from "@/utilities";
import {useForm} from "@inertiajs/vue3";
import {inject, ref} from "vue";
import Button from "@/Components/Buttons/Button.vue";


const route = inject("route");

const form = useForm({
  email: "",
});

const submittedForm = ref(false);
const sendForm = () => {
  form.post(route("api.subscribe-email-form"), {
    preserveState: true,
    preserveScroll: true,
    onSuccess: () => {
      submittedForm.value = true;
    },
    onError: (errors) => form.errors = mapErrors(errors)
  });
};
</script>

<template>
    <p class="text-md mb-4 font-extrabold uppercase md:text-3xl">
        {{ $t("Sign up for our newsletter") }}
    </p>

    <div class="mt-4 lg:mt-8">
        <div class="flex flex-col gap-2">
            <div class="grow">
                <FormKit
                    v-model="form.email"
                    name="email"
                    placeholder="E-mailadres"
                    type="text"
                    :errors="form.errors.email"
                    :classes="{ 'input': '!bg-grey-dark !text-white'}"
                />
            </div>

            <Button
                :label="$t('Subscribe')"
                :form="form"
                @click="sendForm"
            />
        </div>

        <div v-if="submittedForm">
            {{ $t("You are subscribed to the newsletter") }}
        </div>
    </div>
</template>
